import ImagesScrollbarGallery from "@components/ImagesScrollbarGallery";
// import { useTranslationContext } from "@providers/TranslationProvider";
import styles from "./OurHotel.module.scss";
import cx from "classnames";
import _ from "lodash";
// import Button from "@components/Button";

const View = ({ title, description, button, imageListProps }: any) => {
  //   const { i18n } = useTranslationContext();
  const validImages =
    imageListProps && Array.isArray(imageListProps)
      ? imageListProps.filter((img: any) => img && img.src)
      : [];
  const hasValidImages = validImages.length > 0;

  return (
    <div className={cx("inner-large", styles.box)}>
      <div className={cx("flex justify-between", styles.content)}>
        {!!title && (
          <div className={cx(styles.title)}>
            <div className="flex-1 ama-title">{title}</div>
          </div>
        )}
        {!!description && (
          <div className={cx(styles.description)}>
            <div className="ama-content">{description}</div>
          </div>
        )}
        {!!button && <div className={styles.button}>{button}</div>}
        {/* <div className={cx("mx-auto", styles.button)}>
        <Button className="block mx-auto" label="Read more" />
      </div> */}
      </div>
      {hasValidImages && (
        <div className={styles.imageBox}>
          <ImagesScrollbarGallery
            isAuto={true}
            galleryName={`hotel-gallery-${_.kebabCase(title)}`}
            images={validImages}
          />
        </div>
      )}
    </div>
  );
};
export default View;
